<template>
  <sweet-modal
    ref="customer_note_modal"
    :title="(is_new ? 'add_customer_note' : 'edit_customer_note') | t"
    blocking="blocking"
  >
    <div v-if="customer_note">
      <div class="form-group">
        <label>{{ 'note' | t }}</label>
        <textarea class="form-control" v-model="customer_note.note" rows="10"></textarea>
      </div>
      <div class="btn-group pull-right">
        <button class="d-block ml-auto btn btn-lg btn-danger mr-4" v-if="customer_note.id" @click="remove">
          {{ 'delete' | t }}
        </button>
        <button class="d-block ml-auto btn btn-lg btn-success" @click="save_or_update">
          {{ (is_new ? 'create' : 'update') | t }}
        </button>
      </div>
    </div>
  </sweet-modal>
</template>
<script>
import _ from 'lodash';
import Api from '@/store/jsonapi';
import Alerts from '@/utils/alerts';

var _customer_note = () => ({
  note: ''
});

export default {
  props: ['title'],
  data: function () {
    return {
      customer_note: null,
      _orig: null
    };
  },
  computed: {
    is_new: function () {
      return !(this.customer_note && this.customer_note.id);
    }
  },
  methods: {
    open: function (customer_note) {
      if (customer_note === void 0) {
        customer_note = _customer_note();
      } else {
        this._orig = customer_note;
        customer_note = _.cloneDeep(customer_note);
      }

      this.customer_note = customer_note;
      this.$refs.customer_note_modal.open();
    },
    close: function () {
      this.$refs.customer_note_modal.close();
    },
    remove: function () {
      Api.destroy('customer_notes', this.customer_note.id).then(({ data }) => {
        this.$emit('done', this.customer_note);

        this.$refs.customer_note_modal.close();
        Alerts.success({ title: 'Deleted', detail: 'Note was deleted' });
      });
    },
    save_or_update: function () {
      if (this.customer_note.id) {
        this.update();
      } else {
        this.save();
      }
    },
    save: function () {
      Api.create('customer_notes', this.customer_note)
        .then(({ data }) => {
          data.is_new = true;
          Alerts.success({ title: 'Created', detail: 'New note added' });
          this.$emit('done', this.customer_note);

          if (this._orig) {
            Object.assign(this._orig, this.customer_note);
          }
          this.$refs.customer_note_modal.close();
        })
        .catch(({ errors }) => {
          errors.forEach((err) => {
            Alerts.danger(err);
          });
        });
    },
    update: function () {
      delete this.customer_note['staff'];
      Api.update('customer_notes', this.customer_note)
        .then(({ data }) => {
          data.is_updated = true;
          Alerts.success({ title: 'Updated', detail: 'Note updated' });

          this.$emit('customerNoteCreated', this.customer_note);
          if (this._orig) {
            Object.assign(this._orig, this.customer_note);
          }
          this.$refs.customer_note_modal.close();
        })
        .catch(({ errors }) => {
          errors.forEach((err) => {
            Alerts.danger(err);
          });
        });
    }
  }
};
</script>

<style scoped></style>
